import React from 'react';
import { Marker } from 'react-map-gl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import { Port } from '@api/utils/ports';
import styles from './ContractedCargosMarker.module.css';

type ContractedCargosMarkerProps = {
	loadingPort: Port;
	isSelected: boolean;
	onLoadingPortClick: (p: Port) => void;
};

const ContractedCargosMarker = ({
	loadingPort,
	isSelected,
	onLoadingPortClick
}: ContractedCargosMarkerProps) => {
	return (
		<Marker
			key={`marker-${loadingPort.name}`}
			longitude={loadingPort.longitude}
			latitude={loadingPort.latitude}
			className={styles.contractedCargo}
			offsetTop={-14}
			offsetLeft={-14}
		>
			<span className="fa-stack">
				<FontAwesomeIcon
					className={classNames(
						styles.markerIcon,
						{ [styles.selectedMarker]: isSelected }
					)}
					size="lg"
					icon={faCheckCircle}
					onClick={() => onLoadingPortClick(loadingPort)}
				/>
			</span>
		</Marker>
	);
};

export default ContractedCargosMarker;